import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-primary-button',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule],
  templateUrl: './pirmary-button.component.html',
  styleUrl: './pirmary-button.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PrimaryButtonComponent {
  @Input() text: string = 'Continue';
  @Input() style: string = 'flat';
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean = false;

  @Output() eventTriggered: EventEmitter<void> = new EventEmitter();

  triggerEvent() {
    this.eventTriggered.emit();
  }
}
